import { Component, Inject, OnInit } from '@angular/core';
import { NonMemberActivityService } from '../../Services/nonMemberActivity.service';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { PaymentService } from '../../Services/payment.service';
import { DOCUMENT } from '@angular/common';
import { IMyDpOptions, IMyMarkedDate, IMyDayLabels } from 'mydatepicker';

@Component({
  selector: 'app-subscription-non-member',
  template: require('./subscription-non-member.component.html'),
  styles: [require('./subscription-non-member.component.css')]
})
export class SubscriptionNonMemberComponent implements OnInit {
  
  nonmember:any={
    firstname: '',
    lastname: '',
    email: '',
    remarks: '',
    gsm: '',
    team: '',
    birthday: '',
    gender: '',
    streetName: '',
    houseNr: '',
    postalCode: '',
    community: '',
    extraQuestion: false,
    amount: 1,
  }

  activity:any={
    id:0,
    price: 0,
    description: ''
  }
  validActivity:boolean = false;
  EmailSame:boolean = false;

  emailCheckValue:string = ""

  selectedBirthday: any;
  myDatePickerOptions: IMyDpOptions = {
    todayBtnTxt: 'Vandaag',
    dateFormat: 'dd/mm/yyyy',
    firstDayOfWeek: 'mo',
    sunHighlight: true,
    markCurrentDay: true,
    height: '34px',
    width: '210px',
    alignSelectorRight: false,
    openSelectorTopOfInput: false,
    indicateInvalidDate: true,
    monthSelector: true,
    yearSelector: true,
    minYear: 1920,
    maxYear: 2200,
    componentDisabled: false,
    editableDateField:false,
    showClearDateBtn: true,
    showDecreaseDateBtn: false,
    showIncreaseDateBtn: false,
    showSelectorArrow: true,
    showInputField: true,
    openSelectorOnInputClick: false,
    disableHeaderButtons: true,
    showWeekNumbers: false,
    markDates: [],
    satHighlight: false,
    highlightDates: [],
    markWeekends: <IMyMarkedDate>{},
    monthLabels: {
        1: 'Januari',
        2: 'Februari',
        3: 'Maart',
        4: 'April',
        5: 'Mei',
        6: 'Juni',
        7: 'July',
        8: 'Augustus',
        9: 'September',
        10: 'Oktober',
        11: 'November',
        12: 'December'
    },
    dayLabels: <IMyDayLabels>{
      su: 'zo', mo: 'ma', tu: 'di', we: 'wo', th: 'do', fr: 'vr', sa: 'za'
    },
    allowDeselectDate: true,
    disableWeekdays: [],
    allowSelectionOnlyInCurrentMonth: true
  };

  constructor(
    private nonMemberActivityService: NonMemberActivityService,
    private route: ActivatedRoute,
    private router: Router,
    private paymentService:PaymentService,
    @Inject(DOCUMENT)  private document: Document) { 
      route.params.subscribe(p => {
        if (p['id'])
          this.activity.id = +p['id'];
        else
          this.activity.id = 0;
      });
  }

  ngOnInit() {
    this.getNonMemberActivitiesById();
  }

  private getNonMemberActivitiesById(){
    this.nonMemberActivityService.getNonMemberActivitiesById(this.activity.id).subscribe( res =>{
      console.log("getNonMemberActivitiesById: ");
      console.log(res);
      if (res.status == 200){   
        this.activity = res.value
        this.validActivity = true
      }else{
        this.validActivity = false
      }
    })
  }

  // SaveNonMemberSubscription(){
  //   console.log("SaveNonMemberSubscription");
  //   console.log(this.nonmember);


  //   this.nonmember['NonMemberActivityId'] = this.activity.id

  //   this.nonMemberActivityService.create(this.nonmember).subscribe( res =>{
  //     console.log("Create:")
  //     console.log(res);

  //     if (res.status == 200){
  //       var innerhtml = `
  //         <div class="text-center mt-5">
  //           De betaling is gelukt en we verwachten je op ons evenement.         
  //         </div>
  //         `

  //         Swal.fire({
  //           title: "Bedankt om langs te komen!",
  //           type: "success",
  //           html: innerhtml,
            
  //           width: '800px',
  //           showCancelButton: false,
  //           confirmButtonColor: '#3085d6',
  //           confirmButtonText: 'ok',
  //         }).then((result) => {
  //             console.log(result);
  //             if (result.value){
  //               this.router.navigate(["/home"]);
  //             }        
  //         });
  //     }
  //   })
  // }

  // trailButton(){
  //   var url = "https://www.mollie.com/checkout/test-mode?method=mistercash&token=6.8qz1tt";
  //   console.log(url);

  //   this.document.location.href = url
    
  // }

  DoPayment(){
    console.log("DoPayment");
    this.nonmember['NonMemberActivityId'] = this.activity.id
    this.nonmember.birthday = String(this.selectedBirthday.date.year)+"-"+String(this.selectedBirthday.date.month)+"-"+String(this.selectedBirthday.date.day)
    // console.log(this.nonmember);

    this.nonMemberActivityService.create(this.nonmember).subscribe( (res:any) =>{
      // console.log(res);
      
      if (res.status == 200){
          var paymentinfo:any ={
            "amount": {
              "currency": "EUR",
              "value":  (this.activity.normalTarif * this.nonmember.amount).toFixed(2)
            },
            "description": this.activity.subject,
            "category": "nonmemberevent",
            "id": res.value.id
          }

          this.paymentService.initPayment(paymentinfo).subscribe( (res:any) => {
              // console.log("InitPayment");
                
              // console.log(res);
              
              if (res.status  == 200){
                // console.log(res);
                // this.router.navigate(res.value)
                this.document.location.href = res.value.checkouturl
              }
           })
      }
    })
  }



  compareEmail(){
    // console.log("CompareEmail");
    
    if (this.nonmember.email === this.emailCheckValue) {
      this.EmailSame = true
    }else{
      this.EmailSame = false
    }
  }

  checkAdult(): boolean {
    if (this.selectedBirthday !== undefined ){
      var eventDate = new Date(this.activity.beginDate)
      var age18date = new Date(this.selectedBirthday.jsdate)
      age18date.setFullYear(age18date.getFullYear()+18)
      // console.log("---------------------------");
      // console.log("eventDate valid?", !isNaN(eventDate.getTime()));
      // console.log("age18date valid?", !isNaN(age18date.getTime()));

      // console.log(typeof this.selectedBirthday.jsdate, this.selectedBirthday.jsdate);
      
      // console.log("eventDate:" ,eventDate);
      // console.log("Birthdate: ", this.selectedBirthday);
      // console.log("age18date: ", age18date);
      
      // console.log("evantdate: ",eventDate.getTime());
      // console.log("age18date: ",age18date.getTime());

      // console.log("---------------------------");

      return eventDate.getTime() >= age18date.getTime() ;

    }    
    return false
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/subscription-non-member/subscription-non-member.component.ts